import { render } from "./ProductBundleArchive.vue?vue&type=template&id=e66d67c2&scoped=true"
import script from "./ProductBundleArchive.vue?vue&type=script&lang=js"
export * from "./ProductBundleArchive.vue?vue&type=script&lang=js"

import "./ProductBundleArchive.vue?vue&type=style&index=0&id=e66d67c2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e66d67c2"]])

export default __exports__